import { normalize } from 'normalizr';
import { camelizeKeys } from 'humps';
import { parse, stringify } from 'query-string';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';
import { history } from '../store';
import { addSchema } from './schemaActions';
import { openLoginModal } from './authActions';
import { lodgeDetailSchema } from '../Schema';

export const fetchLodge = lodgeId => async (dispatch, getState) => {
  const lodgeAlreadyInStore = getState().schema.lodgeDetail.allIds.includes(lodgeId);
  if (lodgeAlreadyInStore) return;

  try {
    const { data } = await api.get(endpoints.lodge.details(lodgeId));
    const albums = await fetchCoverImages(lodgeId);
    const lodgeData = { ...data, albums };
    const { entities, result } = normalize(camelizeKeys(lodgeData), lodgeDetailSchema);

    dispatch(addSchema(entities.lodgeDetail[result], 'lodgeDetail'));
  } catch (err) {
    console.log(err, 'where are the lodges network');
  }
};

async function fetchCoverImages(lodgeId) {
  try {
    const { data } = await api.get(endpoints.lodge.coverImages(lodgeId));
    return data.images;
  } catch (e) {
    return [];
  }
}

export const addLodgeToTrekDay = lodgeId => async (dispatch, getState) => {
  const isUserLoggedIn = Boolean(getState().user.userId);
  if (!isUserLoggedIn) {
    dispatch(openLoginModal());
    return;
  }

  try {
    const queryParams = parse(window.location.search);
    await api.patch(endpoints.treks.addToTrekDay(queryParams.tid, queryParams.dN), {
      routes: [
        {
          segment_id: queryParams.sid,
          lodgings: [lodgeId],
        },
      ],
    });

    // updating that the lodge has been added to the trek via the search query params
    // so that the component can show respective UI
    queryParams.isAdded = true;
    history.push({
      pathname: window.location.pathname,
      search: stringify(queryParams),
    });
  } catch (err) {
    console.log(err);
  }
};



// WEBPACK FOOTER //
// ./src/redux/actions/lodgeActions.js